import React, { useEffect, useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy'
import marketing from '../../../services/marketing';
import { useFormContext } from 'react-hook-form';
import '../../../assets/terms/acknowledgements.css'
import AdobeScript from '../../../services/adobeScript';
import { tcGenerator } from '../../../services/tcGenerator';
import ErrorModal from '../../body/forms/components/ErrorModal'
import LoadingModal from '../../body/forms/components/LoadingModal';
import { FLOW, PRODUCT } from '../../../models/websiteTypesConstants';

function Acknowledgements({data}) {
    const Setting = useStoreState((state) => state.siteSettingsModel);
    const applicantInfo = useStoreState((state) => state.applicantModel.applicant);
    const mainSettings = useStoreState(state => state.siteSettingsModel.mainSettings);
    const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
    const productSettings = useStoreState(state => state.siteSettingsModel.productSettings);  
    const setInfo = useStoreActions(actions => actions.applicantModel.setApplicant);
    const info = useStoreState((state) => state.applicantModel.applicant);
    const [ProductCode, setProductCode] = useState("")
    const { register,  formState: { errors } } = useFormContext();    
    const utm = new marketing();
    const activeCheck = useStoreState((state) => state.siteSettingsModel.activateChecks); 
    const applicationResult = useStoreState(state => state.applicationResultModel.applicationResult);
    const adobe = new AdobeScript();
    const [errorShow, setErrorShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const closeError = () => setErrorShow(false);
    const [loading, setLoading] = useState(false);

    const handleViewTerms = async (e) => {
        if (e) e.preventDefault();
    
        const ProductCode = localStorage.getItem("TCProductCode");
        setLoading(true);
        try {
            const { fileContent, hasErrors, errorMessage } = await tcGenerator(ProductCode);
            setLoading(false);
            if (hasErrors) {
                setErrorMessage(errorMessage);
                setErrorShow(true);
                return;
            }
            const byteCharacters = atob(fileContent);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
          
          
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");
        } catch (err) {
            setLoading(false)
            setErrorMessage(`${err.message}`);
            setErrorShow(true);
        }
    };

    const handleRetry = () => {
        setErrorShow(false);
        handleViewTerms();
      };

    useEffect(() => {
        setProductCode((applicationResult.product_code !== "") ? applicationResult.product_code : ((applicantInfo.ProductCode !== "") ? applicantInfo.ProductCode: mainSettings.ProductCode))
    },[])

    return (
        <>
            <div  className='col-lg-12'>
            <LoadingModal show={loading} message="Loading Terms & Conditions..." />
            <ErrorModal size='sm' show={errorShow} message={errorMessage} closeError={closeError} onRetry={handleRetry} />
            {
                !activeCheck && (
                    <div className='col-12 mt-3'>
                        <div className="form-check">
                            <input 
                                checked={info.generalAcknowledgement === "1" ? true : false} value={info.generalAcknowledgement}
                                onClick={() => { 
                                    let value =  info.generalAcknowledgement === "1" ? "0" : "1";
                                    setInfo({ index: "generalAcknowledgement", value})
                                    setInfo({ index: "eSignConsent", value })
                                    setInfo({ index: "tcAcknowledgement", value })
                                    adobe.event('acknowledgment_checkpoint');
                                }} 
                                className="form-check-input" 
                                type="checkbox" id="generalAcknowledgement" {...register("generalAcknowledgement")} 
                            />
                            <label className="form-check-label" >
                            <div>
                        I acknowledge that by checking this box and pressing the “Verify and Submit” or “Submit Application” button below,
                        I am completing and signing this Application electronically. I understand that I am applying to {brandSettings.BankName} for a 
                        {brandSettings.ProductName.toLowerCase() === 'fit' ? `${" "+brandSettings.ProductName.toUpperCase()}` : `${" "+brandSettings.ProductName}`} Mastercard<sup>®</sup> credit card, and that by submitting this application, I am authorizing the following: The Bank may obtain and use credit bureau
                        reports on me, verify my employment history, contact me by mail, phone, text, or email, and exchange information
                        about me in connection with this Application and any update, extension of credit, review, or collection of my Account. Finally,
                        I confirm that I have read and agree to all of the{' '}
                        {/* eslint-disable-next-line */}
                        {
                            info.IsRollUpCode ? 
                            <>
                                <a   href={productSettings.TermsUrl} target="_blank" rel="noopener noreferrer" className="button-link" onClick={() => {utm.updateSessionReport("termsLink"); localStorage.setItem("TCProductCode", data.productCode)}} ><u>Account Opening Disclosure</u></a>
                            </>
                            :
                            <>
                                <a   href="#" target="_blank" rel="noopener noreferrer" className="button-link" onClick={(e) => {e.preventDefault(); handleViewTerms(); utm.updateSessionReport("termsLink"); localStorage.setItem("TCProductCode", data.productCode)}} ><u>Account Opening Disclosure</u></a>
                            </>
                        }
                        , <a  onClick={() => { utm.updateSessionReport("privacyLink") }}  href={productSettings.PrivacyUrl} target="_blank" rel="noopener noreferrer"><u>Privacy Notice</u></a>
                        , <a  onClick={() => { utm.updateSessionReport("IdentityAdvantageTermsLink") }}  href={productSettings.IdentityAdvantageTermsUrl} target="_blank" rel="noopener noreferrer"><u>Identity Advantage Terms and Conditions</u></a>
                        , <a onClick={() => { utm.updateSessionReport("eConsentLink") }} href={Setting.brandSettings.ProductName === PRODUCT.Grand.bank ? Setting.webAssetsBaseUrlSettings.Cdn + Setting.productSettings.OmpsUrl : Setting.productSettings.OmpsUrl} target="_blank" rel="noopener noreferrer"><u>Online Mobile Privacy Statement</u></a>, and <a rel="noopener noreferrer" target="_blank" href={productSettings.ESignUrl}> <u>Electronic Communications Disclosure</u></a>, and have printed or retained an electronic copy for my records.
                    {
                        activeCheck && (
                            <table>
                                <tbody>
                                    <tr>                        
                                        <td>
                                            <div className="form-check">
                                                <input  checked={info.generalAcknowledgement === "1" ? true : false} value={info.generalAcknowledgement} onClick={(e) => {  setInfo({ index: "generalAcknowledgement", value: info.generalAcknowledgement === "1" ? "0" : "1" }); utm.updateSessionReport("iAgreeButton") }} className="form-check-input" type="checkbox" id="generalAcknowledgement" {...register("generalAcknowledgement")} />
                                                <label className="form-check-label" htmlFor="generalAcknowledgement">
                                                    I agree to the Acknowledgements
                                                </label>
                                            </div>
                                            {errors.generalAcknowledgement ? 
                                                <div className="col-12 error-message"> You must acknowledge before continue. </div>
                                                :
                                                <></>
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        )
                    }
                </div>
                {
                    
                    mainSettings.Flow === FLOW.CFC && brandSettings.ProductName === FLOW.Fit && (
                    <div className="col-lg-12 p-0 mt-3">
                        <div className='terms-acknowledgements-box'>
                        <p>
                        I consent and understand that {brandSettings.BankName} and Continental Finance Company will use any information I provide to apply for a credit product to enable 
                        physical and digital communications from selected affiliated and non-affiliated marketing partners in compliance with the <a rel="noopener noreferrer" href={productSettings.PrivacyUrl} target="_blank">Privacy Notice</a>. My consent is not required 
                        for approval of this application. If I receive any email communications from affiliated or non-affiliated marketing partners, I understand that I can unsubscribe at 
                        any time by clicking the unsubscribe link in that email message.
                        </p>
                        {
                            activeCheck && (
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="form-check">
                                                    <input onClick={() => { }} className="form-check-input" type="checkbox" value="" id="emailOffers" {...register("emailOffers")} />
                                                    <label className="form-check-label" htmlFor="emailOffers">
                                                        I consent and understand
                                                </label>
                                                </div>
                                                {errors.emailOffers ? 
                                                    <div className="col-12 error-message"> You must acknowledge before continue. </div>
                                                    :
                                                    <></>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        }
                        
                    </div>
                </div>)
                }
                            </label>
                        {errors.generalAcknowledgement ? 
                        <div className="col-12 error-message"> You must acknowledge before continue. </div>
                        :
                        <></>
                        }
                        </div>
                    </div>
                )
            }
            <br></br>
        </div>
        </>
    )    
}

export default Acknowledgements